import { CloudProvider } from "./cloud-provider";
import { CollectionToCopy } from "./collection-to-copy";

export class CopyPlatformRequest {
  sourcePlatformId: number | null = 0;
  rootGroupName: string | null = null;
  rootUserLogin: string | null = null;
  rootUserEmail: string | null = null;
  rootUserPassword: string | null = null;
  platformName: string | null = null;
  platformBaseUrl: string | null = null;
  platformLoginSuffix: string | null = null;
  collectionsToCopy: CollectionToCopy[] | null = null;
  specifiedNewPlatformId: number | null = 0;
  duplicateResources: boolean = false;
  copyUserGroups: boolean = false;
  cloudProvider: CloudProvider | null = null;
  billingOfferId: number | null = null;

  constructor(init?: Partial<CopyPlatformRequest>) {
    Object.assign(this, init);
  }
}
